<template>
  <div class="loading-page">
    <div class="loading-content">
      <div class="spinner"></div>
      <div class="loading-text">{{ loadingText }}</div>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import { getToken } from '@/utils/auth'
export default {
  name: 'LoadingPage',
  data() {
    return {
      loadingText: '正在加载...',
      isMobile:false,
      // 可以添加其他控制变量
    }
  },
  mounted() {
    this.checkMobile()
    // 模拟加载过程
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')
    if(code)
    {
      sessionStorage.setItem('touser', code);
    }

    const token = getToken('token')
    if(token){
      if(this.isMobile)
      {
          this.$router.push({ path: "/mobile" });
      }else{
          this.$router.push({ path: "/" })
      }
    }else{
      this.$router.push({ path: "/login" })
    }


  },
  methods: {
    checkMobile() {
      this.isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
    },
  }
}
</script>

<style scoped>
.loading-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
  transform: translateY(-50%);
}

.spinner {
  width: 50px;
  height: 50px;
  margin: 0 auto;
  border: 4px solid #e0e0e0;
  border-top: 4px solid #409EFF;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-text {
  margin-top: 20px;
  font-size: 16px;
  color: #666;
  font-family: Arial, sans-serif;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 可选进度条样式 */
/*
.progress-bar {
  width: 200px;
  height: 4px;
  background: #eee;
  margin: 20px auto;
  border-radius: 2px;
  overflow: hidden;
}

.progress {
  width: 0%;
  height: 100%;
  background: #409EFF;
  transition: width 0.3s ease;
}
*/
</style>